import { Divider, Flex, Typography } from "antd";
import Countdown, { weddingDate } from "../components/Countdown";
import PhotoCarousel from "../components/PhotoCarousel";
import About from "../components/About";
import Map from "../components/Map";

const Home = () => {
  return (
    <Flex vertical align="center" style={{ width: '100%' }}>
      <Typography.Title style={{ margin: 0 }}>Ella & Ryan's Wedding</Typography.Title>
      <Typography.Title level={3} style={{ margin: 10 }}>{weddingDate.toDateString()}</Typography.Title>
      <Typography.Title level={4} style={{ margin: '0 0 10px 0' }}>Victoria, BC, Canada</Typography.Title>

      <Countdown />

      <Divider />

      <PhotoCarousel />

      <Divider />

      <Map />

      <Divider />

      <About />

      <Divider />

      <video width='100%' controls autoPlay muted src="./tree.mp4" />
    </Flex>
  );
};

export default Home;